import React, { useState, useEffect } from 'react';
import { analyticsService } from '../../services/analyticsService';

interface AnalyticsEvent {
  timestamp: string;
  event: string;
  parameters?: Record<string, any>;
}

const AnalyticsDebug: React.FC = () => {
  const [events, setEvents] = useState<AnalyticsEvent[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show in development
    if (process.env.NODE_ENV === 'development') {
      setIsVisible(true);
    }
  }, []);

  // Mock function to add events to the list
  const addEvent = (eventName: string, parameters?: Record<string, any>) => {
    const newEvent: AnalyticsEvent = {
      timestamp: new Date().toLocaleTimeString(),
      event: eventName,
      parameters,
    };
    setEvents(prev => [newEvent, ...prev.slice(0, 9)]); // Keep last 10 events
  };

  // Override console.log for analytics events
  useEffect(() => {
    const originalLog = console.log;
    console.log = (...args) => {
      if (args[0]?.includes('📊 Analytics:')) {
        const eventName = args[0].split('📊 Analytics: ')[1];
        const parameters = args[1];
        addEvent(eventName, parameters);
      }
      originalLog.apply(console, args);
    };

    return () => {
      console.log = originalLog;
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '400px',
      maxHeight: '300px',
      backgroundColor: '#f5f5f5',
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '10px',
      fontSize: '12px',
      zIndex: 1000,
      overflow: 'auto',
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>
        <span>📊 Analytics Debug</span>
        <button 
          onClick={() => setEvents([])}
          style={{ 
            background: '#ff4444', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px',
            padding: '2px 8px',
            cursor: 'pointer'
          }}
        >
          Clear
        </button>
      </div>
      
      {events.length === 0 ? (
        <div style={{ color: '#666', fontStyle: 'italic' }}>
          No analytics events yet...
        </div>
      ) : (
        <div>
          {events.map((event, index) => (
            <div key={index} style={{ 
              marginBottom: '8px', 
              padding: '8px', 
              backgroundColor: 'white',
              borderRadius: '4px',
              border: '1px solid #ddd'
            }}>
              <div style={{ fontWeight: 'bold', color: '#333' }}>
                {event.timestamp} - {event.event}
              </div>
              {event.parameters && (
                <div style={{ 
                  marginTop: '4px', 
                  fontSize: '11px', 
                  color: '#666',
                  fontFamily: 'monospace'
                }}>
                  {JSON.stringify(event.parameters, null, 2)}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalyticsDebug; 